<template>
    <div class="content pb-2">
        <Header
            :title="
                this.hasEdit ? this.$t('form_customer_v2.breadcrum.label_mod') : this.$t('form_customer_v2.breadcrum.label_new')
            "
        />
        <BackButton :baseUrl="baseUrl" />
        <div class="ppv2-pb-6 ppv2-rounded-3xl ppv2-mb-2 ppv2-overflow-hidden">
            <ActionSection
                v-if="hasEdit"
                :user="user"
                :customer="customer"
                :spentIn="spentIn"
                :symbolCurrency="symbolCurrency"
                :csrf="csrf"
                :walletBalance="walletBalance"
                :routes="routes"
                :origins="origins"
                :customerGroup="customerGroup"
                :gender="gender"
            />
            <!-- Main Info Section -->
            <div class="ppv2-flex ppv2-flex-col">
                <div class="ppv2-w-full">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ this.$t('form_customer_v2.main_information.title_infomation') }}
                    </h3>
                </div>
                <form enctype="multipart/form-data">
                    <div class="ppv2-flex ppv2-justify-center">
                        <div class="ppv2-m-auto ppv2-w-[80%] sm:ppv2-w-10/12 ppv2-pb-0">
                            <div class="ppv2-flex-wrap">
                                <BoCustomerGeneralInformations
                                    :hasEdit="hasEdit"
                                    ref="infoRef"
                                    :customer="customer"
                                    :customerGroup="customerGroup"
                                    :user="user"
                                    :gender="gender"
                                    :origins="origins"
                                    :lastRgpd="lastRgpd"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--  -->
            <div class="ppv2-my-8 ppv2-flex ppv2-justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="802" height="2" viewBox="0 0 802 2" fill="none">
                    <path d="M1 1H801" stroke="#94A3B8" stroke-opacity="0.2" stroke-linecap="round"></path>
                </svg>
            </div>
            <!-- Address Section -->
            <div class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] sm:ppv2-w-10/12 ppv2-pb-0">
                    <div class="ppv2-flex-wrap">
                        <BoCustomerAddress ref="infoAdress" :user="user" :adresse="adresse" :hasEdit="hasEdit" />
                    </div>
                </div>
            </div>

            <div class="ppv2-my-8 ppv2-flex ppv2-justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="802" height="2" viewBox="0 0 802 2" fill="none">
                    <path d="M1 1H801" stroke="#94A3B8" stroke-opacity="0.2" stroke-linecap="round" />
                </svg>
            </div>
            <!-- Note Interne Section -->
            <div class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] sm:ppv2-w-10/12 ppv2-pb-0">
                    <div class="ppv2-flex-wrap">
                        <BoCustomerNoteInterne
                            ref="infoNote"
                            :user="user"
                            :noteCategories="noteCategories"
                            :userNoteCategories="userNoteCategories"
                        />
                    </div>
                </div>
            </div>

            <div class="ppv2-my-8 ppv2-flex ppv2-justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="802" height="2" viewBox="0 0 802 2" fill="none">
                    <path d="M1 1H801" stroke="#94A3B8" stroke-opacity="0.2" stroke-linecap="round" />
                </svg>
            </div>
            <!-- Alert Section -->
            <div class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] sm:ppv2-w-10/12 ppv2-pb-0">
                    <div class="ppv2-flex-wrap">
                        <BoCustomerAlert
                            ref="infoAlert"
                            :user="user"
                            :customer="customer"
                            :alertCategories="alertCategories"
                            :userAlertCategories="userAlertCategories"
                        />
                    </div>
                </div>
            </div>

            <div class="block-header justify-content-center gap-40 d-flex flex-wrap px-6">
                <BaseButton id="reset" @click="resetForm" type="reset" variant="outline" customClass="reset">
                    {{ $t('form_customer_v2.btn.reset') }}
                </BaseButton>
                <BaseButton id="submit" @click="submitForm" type="button" variant="primary">
                    {{ $t('form_customer_v2.btn.validate') }}
                </BaseButton>
            </div>

            <div v-if="hasEdit" class="ppv2-my-8 ppv2-flex ppv2-justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="802" height="2" viewBox="0 0 802 2" fill="none">
                    <path d="M1 1H801" stroke="#94A3B8" stroke-opacity="0.2" stroke-linecap="round" />
                </svg>
            </div>

            <div v-if="hasEdit" class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] ppv2-sm:ppv2-w-10/12 ppv2-pb-0">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ $t('title_datatable_customer_booking_v2_edit') }}
                    </h3>
                    <div class="ppv2-flex-wrap">
                        <BoCustomerBookingDatatable :user="user" />
                    </div>
                </div>
            </div>

            <div v-if="hasEdit" class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] ppv2-sm:ppv2-w-10/12 ppv2-pb-0">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ $t('title_datatable_customer_products_purchased_v2_edit') }}
                    </h3>
                    <div class="ppv2-flex-wrap">
                        <BoCustomerProductsPurchasedDatatable :user="user" />
                    </div>
                </div>
            </div>

            <div v-if="hasEdit" class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] ppv2-sm:ppv2-w-10/12 ppv2-pb-0">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ $t('title_datatable_customer_vouchers_purchased_v2_edit') }}
                    </h3>
                    <div class="ppv2-flex-wrap">
                        <BoCustomerVouchersPurchasedDatatable :user="user" />
                    </div>
                </div>
            </div>

            <div v-if="hasEdit" class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] ppv2-sm:ppv2-w-10/12 ppv2-pb-0">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ $t('title_datatable_customer_treatement_v2_edit') }}
                    </h3>
                    <div class="ppv2-flex-wrap">
                        <BoCustomerTreatementDatatable :user="user" />
                    </div>
                </div>
            </div>

            <div v-if="hasEdit" class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] ppv2-sm:ppv2-w-10/12 ppv2-pb-0">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ $t('title_datatable_customer_serie_v2_edit') }}
                    </h3>
                    <div class="ppv2-flex-wrap">
                        <BoCustomerSerieDatatable :user="user" />
                    </div>
                </div>
            </div>

            <div v-if="hasEdit" class="ppv2-flex ppv2-justify-center">
                <div class="ppv2-m-auto ppv2-w-[80%] ppv2-sm:ppv2-w-10/12 ppv2-pb-0">
                    <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                        {{ $t('title_datatable_customer_email_v2_edit') }}
                    </h3>
                    <div class="ppv2-flex-wrap">
                        <BoCustomerEmailDatatable :user="user" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../Shared/Header.vue'
import ActionSection from './v2/ActionSection.vue'
import ApiManager from './Api/v2/ApiManagerBoCutomer.js'
import BoCustomerGeneralInformations from './v2/BoCustomerGeneralInformations.vue'
import BoCustomerAddress from './v2/BoCustomerAddress.vue'
import BoCustomerNoteInterne from './v2/BoCustomerNoteInterne.vue'
import BoCustomerAlert from './v2/BoCustomerAlert.vue'
import BackButton from '../Shared/BackButton.vue'
import BoCustomerEmailDatatable from './v2/BoCustomerEmailDatatable.vue'
import BoCustomerBookingDatatable from './v2/BoCustomerBookingDatatable.vue'
import BoCustomerProductsPurchasedDatatable from './v2/BoCustomerProductsPurchasedDatatable.vue'
import BoCustomerVouchersPurchasedDatatable from './v2/BoCustomerVouchersPurchasedDatatable.vue'
import BoCustomerTreatementDatatable from './v2/BoCustomerTreatementDatatable.vue'
import BoCustomerSerieDatatable from './v2/BoCustomerSerieDatatable.vue'
import BaseButton from '../Shared/BaseButton.vue'

export default {
    components: {
        Header,
        ActionSection,
        BoCustomerGeneralInformations,
        BoCustomerAddress,
        BoCustomerNoteInterne,
        BoCustomerAlert,
        BackButton,
        BoCustomerEmailDatatable,
        BoCustomerBookingDatatable,
        BoCustomerProductsPurchasedDatatable,
        BoCustomerVouchersPurchasedDatatable,
        BoCustomerTreatementDatatable,
        BoCustomerSerieDatatable,
        BaseButton,
    },
    props: [
        'baseUrl',
        'user',
        'customer',
        'spentIn',
        'symbolCurrency',
        'csrf',
        'walletBalance',
        'routes',
        'customerGroup',
        'gender',
        'origins',
        'lastRgpd',
        'adresse',
        'noteCategories',
        'userNoteCategories',
        'alertCategories',
        'userAlertCategories',
        'hasEdit',
    ],
    data() {
        return {}
    },
    methods: {
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        async submitForm() {
            if (this.$refs.infoRef.validate() && this.$refs.infoAdress.validate()) {
                const userData = this.$refs.infoRef.object_user
                const customerData = this.$refs.infoRef.object_customer
                const rgbdData = this.$refs.infoRef.$refs.rgbd.object_rgpd
                const adresse = this.$refs.infoAdress.object_adress
                const infoNote = this.$refs.infoNote.notes_internes
                const infoAlert = this.$refs.infoAlert.notes_alerts
                const no_show = this.$refs.infoAlert.customer.no_show

                const data = {
                    user: userData,
                    customer: customerData,
                    rgbd: rgbdData,
                    adresse: adresse,
                    infoNote: infoNote,
                    infoAlert: infoAlert,
                    no_show: no_show,
                }
                try {
                    const _data = await ApiManager.updateustomers(JSON.stringify(data))
                    this.showMessageNotification(_data.message, 'success')
                } catch (error) {
                    this.$toast.error(error.response.data.message)
                } finally {
                }
            }
        },
        resetForm() {
            this.$refs.infoRef.reset()
            this.$refs.infoAdress.reset()
        },
    },
}
</script>
